import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getPricingPlans = async (selectedDomain: string, iso: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `pricing-plans`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        params: { iso },
        isEncrypted: true,
    });
}